'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var aes = require('crypto-js/aes');
var cryptoJs = require('crypto-js');

/**
 * Encrypt data using AES-256-CBC
 * @param data
 * @param key Must be a 256 bits hex string
 * @param iv Must be a 128 bits hex string
 * @returns Encrypted data as a hex string
 */
function encrypt(data, key, iv) {
    if (key.length !== 64)
        throw new Error('Key must be 256 bits long');
    if (iv.length !== 32)
        throw new Error('IV must be 128 bits long');
    const cipher = aes.encrypt(data, cryptoJs.enc.Hex.parse(key), {
        mode: cryptoJs.mode.CBC,
        padding: cryptoJs.pad.Pkcs7,
        iv: cryptoJs.enc.Hex.parse(iv),
    });
    return cryptoJs.enc.Hex.stringify(cipher.ciphertext);
}

exports.encrypt = encrypt;
//# sourceMappingURL=aes256.js.map
